export const PRINT_WIDTH = 1920;
export const PRINT_HEIGHT = 2715;
